import type { Resource } from '../../';
export const product_group_unisex: Resource = {"default":"Unisex"};
